import React from 'react';
import { motion } from 'framer-motion';
import { Play, ExternalLink } from 'lucide-react';

export const VideoOverview = () => {
    return (
        <section className="py-20 px-8 max-w-7xl mx-auto">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-12"
            >
                <div className="flex items-center gap-4 mb-6">
                    <div className="p-3 bg-red-100 rounded-2xl">
                        <Play className="w-8 h-8 text-red-600" />
                    </div>
                    <div>
                        <h2 className="text-4xl font-black text-gray-900 tracking-tight">Video Overview</h2>
                        <p className="text-lg text-gray-500 font-medium mt-1">
                            A visual summary of the NRCF framework and thesis contributions
                        </p>
                    </div>
                </div>

                <div className="bg-gray-900 rounded-3xl overflow-hidden shadow-2xl aspect-video relative group">
                    <video
                        className="w-full h-full object-cover"
                        controls
                        poster="/images/video-poster.png" // Optional: You might want to add a poster image later
                    >
                        <source src="/videos/The_AI_Network_Doctor.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    {/* Fallback / Additional Link Overlay */}
                    <div className="absolute inset-0 flex items-center justify-center bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                        {/* This overlay is just for visual effect or if video fails to load, 
                             but native controls usually handle interaction. 
                             We'll keep it simple for now and provide a link below. */}
                    </div>
                </div>

                <div className="mt-6 flex justify-center">
                    <a
                        href="https://notebooklm.google.com/notebook/88960edb-89cd-4302-b2de-574464411803?artifactId=4b1f8e43-6fac-4c6d-8e04-86450ef7ca86"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-6 py-3 bg-blue-50 text-blue-600 rounded-full font-bold hover:bg-blue-100 transition-colors"
                    >
                        <ExternalLink className="w-4 h-4" />
                        View on NotebookLM
                    </a>
                </div>
            </motion.div>
        </section>
    );
};
